// extracted by mini-css-extract-plugin
module.exports = {"background":"style__background__PPU9L","content":"style__content__Tc5fu"};